import { css } from '@emotion/react';
import { CallIntelUtils } from '@frontend/api-call-intel';
import { DemoDataBanner } from '@frontend/analytics-shared';
import { getUser } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { useTranslationTokens } from '@frontend/i18n-tokens';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { trackingIds } from '../../tracking-ids';
import { useCallIntelDemoFlags } from './hooks/use-call-intel-demo-flags';

export const CallIntelDemoBanner = () => {
  const { navigate } = useSettingsNavigate();
  const { t } = useTranslation('analytics');
  const { showDemoChipAndBanner } = useCallIntelDemoFlags();
  const isDemoUser = CallIntelUtils.isDemoUser(getUser()?.username);
  const { patientPossessivePlural: patientPossessivePluralToken } = useTranslationTokens();

  if (!showDemoChipAndBanner) {
    return null;
  }
  return (
    <DemoDataBanner
      css={css`
        margin-bottom: ${theme.spacing(1)};
        position: static;
      `}
      omitCta={isDemoUser}
      ctaText={t('Subscribe Today')}
      onCTAClick={() => navigate({ to: '/subscriptions/feature/:id', params: { id: 'call-intelligence' } })}
      startTrialTrackingId={trackingIds.callIntel.demoDataBannerSelfSubscribe}
      subtitle={t(
        'As a subscriber, you will gain access to insights that will help uncover your {{patientPossessivePluralToken}} specific needs and identify missed revenue opportunities for your practice.',
        {
          patientPossessivePluralToken,
        }
      )}
      title={t("You're exploring the power of Call Intelligence with demo data.")}
    />
  );
};
